import {
  ResetPassword as ResetPasswordComponent,
  ResetPasswordConfirmation,
  MessageContainer,
} from "@asayinc/component-library";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useResetPasswordMutation } from "src/store/sso";

interface FormFields {
  password: string;
  passwordConfirmation: string;
}

export function ResetPassword() {
  document.title = "Reset Password | Say Intermediary Portal";
  const [token, setToken] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const parsedParams = Object.fromEntries(
    new URLSearchParams(window.location.search)
  );
  const [resetPassword, response] = useResetPasswordMutation();

  const submitForm = (data: FormFields, token: string, email: string) => {
    resetPassword({
      email,
      token,
      password: data.password,
      passwordConfirm: data.passwordConfirmation,
    });
  };

  useEffect(() => {
    setToken(parsedParams.token as string);
    setEmail(parsedParams.email as string);
  }, [parsedParams]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <MessageContainer>
        {response.isSuccess ? (
          <ResetPasswordConfirmation />
        ) : (
          <ResetPasswordComponent
            submitForm={(data) => submitForm(data, token, email)}
          />
        )}
      </MessageContainer>
    </Box>
  );
}
